module.exports = __webpack_public_path__ + "static/media/kakao-map.f08e1f87.png";